import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Headers, Http, Request, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { Payment } from './payment.model';
import { PaymentStatus } from './payment-types.enum';
import { EnumTextValuesPipe } from '../pipes/enum-keys-text.pipe';
import { TeamMember } from '../../features/team/team.model';
import { Contact } from '../../features/contacts/contact.model';
import { ContactService } from '../../features/contacts/contact.service';
import { TeamService } from '../../features/team/team.service';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class PaymentService implements OnDestroy {

  /* sets up the dropdown type options */
  paymentStatusOptions: any = this.enumTextValuesPipe.transform(PaymentStatus, ['']);

  keepSubscriptionsAlive = true;
  teamMembers: TeamMember[];
  contacts: Contact[];

  // dropdown settings
  dtSettings = {
    bigBanner: true,
    closeOnSelect: true,
    timePicker: true,
    format: 'dd/MM/yyyy hh:mm a',
    defaultOpen: false
  };

  // employee drop down
  employeesDropdownList = [];

  // contact drop down
  contactsDropdownList = [];


  constructor(
    private http: HttpClient,
    private contactService: ContactService,
    private teamService: TeamService,
    private toastr: ToastrService,
    private enumTextValuesPipe: EnumTextValuesPipe
  ) { }

  ngOnDestroy() { this.keepSubscriptionsAlive = false; }

  getTeamMembersList() {

    this.teamService.getTeamMembers()
      .takeWhile(() => this.keepSubscriptionsAlive)
      .subscribe(
        res => {
          this.teamMembers = <TeamMember[]>res;
          this.createEmployeesDropdownList();
        },
        error => console.log(error),
    );

  }

  getContactsList(contacts: Contact[]) {

    // if its just a list of ids, we need to get them
    if (typeof contacts[0] === 'string') {

      const contactIds = contacts.join();

      // get them from their ids
      this.contactService.getContactsFromIds(contactIds)
        .takeWhile(() => this.keepSubscriptionsAlive)
        .subscribe(
          res => {
            this.contacts = <Contact[]>res;
            this.createContactsDropdownList();
          },
          error => console.log(error),
      );

    } else {

      // else, we can just do the contacts drop down
      this.contacts = contacts;
      this.createContactsDropdownList();
    }


  }

  createEmployeesDropdownList() {
    this.employeesDropdownList = this.teamMembers.map(tm => ({ 'id': tm._id, 'itemName': tm.firstName + ' ' + tm.lastName, 'teamMember': tm }));

  }
  createContactsDropdownList() {
    // console.log('list of contacts', this.contacts);
    this.contactsDropdownList = this.contacts.map(c => ({ 'id': c._id, 'itemName': c.firstName + ' ' + c.lastName, 'contact': c }));
  }




  searchPayments(searchString: string): Observable<Payment[]> {
    // see https://github.com/surfer77/mongoose-string-query for full API!
    return this.http.get<Payment[]>('/api/payments/search?' + searchString).map((payments: Payment[]) => {
      return payments;
    }).catch(this.handleError);

  }

  // Defines routes for payment data retrieval
  getPayments(): Observable<Payment[]> {
    return this.http.get<Payment[]>('/api/payments').map((payments: Payment[]) => {
      return payments;
    }).catch(this.handleError);
  }

  getPaymentsFromIds(contactIds: string): Observable<Payment[]> {
    return this.http.get<Payment[]>(`/api/payments/listByIds/${contactIds}`);
    // ).get(requireAuth, contactCtrl.get);
  }

  // returnCommuncatoinsFromIds(commsIds: ){

  // }

  countPayments(): Observable<number> {
    return this.http.get<number>('/api/payments/count');
  }

  addPayment(payment: Payment): Observable<Payment> {
    return this.http.post<Payment>('/api/payment', payment);
  }

  getPaymentFromId(id: string): Observable<Payment> {
    return this.http.get<Payment>(`/api/payment/${id}`);
  }

  getPayment(payment: Payment): Observable<Payment> {
    return this.http.get<Payment>(`/api/payment/${payment._id}`);
  }

  editPayment(payment: Payment): Observable<string> {
    return this.http.put(`/api/payment/${payment._id}`, payment, { responseType: 'text' });
  }

  deletePayment(payment: Payment): Observable<string> {
    return this.http.delete(`/api/payment/${payment._id}`, { responseType: 'text' });
  }


  private handleError(error: Response) {
    return Observable.throw(error.statusText);
  }


}



// WEBPACK FOOTER //
// ./client/app/shared/payments/payment.service.ts